export default "__VITE_ASSET__DHKTe$fg__"